export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7783.d4713dd5.jpg";